var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4991 0C6.0433 0 -0.000854492 6.04416 -0.000854492 13.5C-0.000854492 20.9558 6.0433 27 13.4991 27C20.955 27 26.9991 20.9558 26.9991 13.5C26.9991 6.04416 20.955 0 13.4991 0ZM8.0299 6.75C9.0765 6.75 9.72102 7.43648 9.74088 8.33777C9.74088 9.22039 9.0765 9.92663 8.00974 9.92663H7.99019C6.96308 9.92663 6.29907 9.22039 6.29907 8.33777C6.29907 7.43648 6.9833 6.75 8.0299 6.75ZM6.48059 11.1814H9.53998V20.3736H6.48059V11.1814ZM20.5725 15.1029C20.5725 12.2794 19.0632 10.9653 17.0499 10.9653C15.4256 10.9653 14.6984 11.8575 14.2923 12.4834V11.1814H11.2325C11.2729 12.044 11.2325 20.3736 11.2325 20.3736H14.2923V15.2399C14.2923 14.9652 14.3122 14.6912 14.3931 14.4945C14.6142 13.9456 15.1176 13.3774 15.9628 13.3774C17.0703 13.3774 17.5131 14.2203 17.5131 15.4556V20.3734H20.5723L20.5725 15.1029Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.54a737bd9d2d9936234a342003d917b6.svg";
export { ForwardRef as ReactComponent };